var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('site-header'),_c('extra-health-plans'),_c('site-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }